import { render } from "./ReserveGenbaModal.vue?vue&type=template&id=ef9c741e&scoped=true"
import script from "./ReserveGenbaModal.vue?vue&type=script&lang=js"
export * from "./ReserveGenbaModal.vue?vue&type=script&lang=js"

import "./ReserveGenbaModal.vue?vue&type=style&index=0&id=ef9c741e&scoped=true&lang=css"

import exportComponent from "/Users/masayukitenma/Documents/Develop/Container/claudedocs/l13-check/fe-build/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9c741e"]])

export default __exports__